<template>
  <div class="text-left">
    <!-- Button -->
    <b-btn v-on:click="this.show" :variant="btnVariant" :size="btnSize">Bankverbindung</b-btn>

    <!-- Modal -->
    <b-modal ref="bankmodal" :title="'Unsere Kontodaten:'" :ok-only=true>
      <p>
        makiri GmbH<br/>
        GLS Bank<br/>
        IBAN: DE08 4306 0967 1159 1563 00<br/>
        BIC: GENODEM1GLS
      </p>
      <p>Betreff: "{{ subject }}"</p>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'BankDetails',
  props: ['school', 'buttonSize', 'buttonVariant'],
  computed: {
    subject: function () {
      if (!this.school) {
        return 'Name und Ort der Schule'
      }

      return this.school.name + ', ' + this.school.city
    },

    btnSize: function () {
      if (this.buttonSize) {
        return this.buttonSize
      }

      return 'sm'
    },

    btnVariant: function () {
      if (this.buttonVariant) {
        return this.buttonVariant
      }

      return 'primary'
    }
  },

  methods: {
    show: function () {
      this.$refs.bankmodal.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/BankDetails.vue